import { LogIn } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconLogIn12Line = createIcon(LogIn, 12, "Line");
export const IconLogIn16Line = createIcon(LogIn, 16, "Line");
export const IconLogIn20Line = createIcon(LogIn, 20, "Line");
export const IconLogIn24Line = createIcon(LogIn, 24, "Line");
export const IconLogIn32Line = createIcon(LogIn, 32, "Line");
export const IconLogIn48Line = createIcon(LogIn, 48, "Line");
export const IconLogIn64Line = createIcon(LogIn, 64, "Line");
